import { productBussiness } from "api/bussiness/product/product-bussiness";
import { GetProducts } from "api/models/request/product/product";
import { Pagination } from "api/models/response/pagination";
import {
  createConditionalNaturalLanguageString,
  formatNumber,
} from "commons/ultilities";
import { flow, types } from "mobx-state-tree";
import { withRootStore } from "mobx-stores/_extension/with-root-store";
import {
  IProductProperties,
  Product,
} from "mobx-stores/_models/products/product";
import { withSetPropAction } from "../_extension/with-set-props";
import { PaginationStore } from "./common/pagination-store";
export const ProductQueryParams = types
  .model({
    dealingName: "",
    code: "",
    name: "",
    barcode: "",
    showDisabled: false,
    isExactMatch: true,
  })
  .actions(withSetPropAction)
  .views((self) => ({
    get natureLanguageString() {
      const map = new Map<
        string,
        { label: string; value: string | number | null | undefined }
      >([
        ["dealingName", { label: "tên giao dịch", value: self.dealingName }],
        ["name", { label: "tên hàng", value: self.name }],
        ["code", { label: "mã hàng", value: self.code }],
        ["barcode", { label: "mã barcode", value: self.barcode }],
      ]);

      return createConditionalNaturalLanguageString(map);
    },
  }));
export const ProductManagement = types
  .model({
    products: types.optional(types.array(Product), []),
    productDetail: types.maybeNull(Product),
    pagination: types.optional(PaginationStore, {}),
    openNew: false,
    openEdit: false,
    openDelete: false,
    openUpdateMaterial: false,
    openPrintPreview: false,
    openUpdateDimensionAndWeight: false,
    openUpdateApproval: false,
    openUpdateManufactoring: false,
    queryParams: types.optional(ProductQueryParams, {}),
    searchConditionAsNaturalLanguage: "",
  })
  .extend(withRootStore)
  .actions(withSetPropAction)
  .actions((self) => ({
    createSearchConditionAsNaturalLanguage() {
      const queryParamsAsNaturalLanguage =
        self.queryParams.natureLanguageString;
      return `${
        queryParamsAsNaturalLanguage ? `${queryParamsAsNaturalLanguage} - ` : ""
      }Tổng cộng: ${formatNumber(self.pagination.totalItems)} mặt hàng`;
    },
  }))
  .actions((self) => ({
    getProducts: flow(function* getProducts(request?: GetProducts) {
      try {
        self._rootStore.setProp("inProgress", true);
        if (!request) {
          request = {
            maxResultCount: self.pagination.itemsPerPage,
            skipCount: self.pagination.skipCount,
            code: self.queryParams.code,
            dealingName: self.queryParams.dealingName,
            name: self.queryParams.name,
            barcode: self.queryParams.barcode,
            isDisabled: self.queryParams.showDisabled,
            isExactMatch: self.queryParams.isExactMatch,
          };
        }

        const res = (yield productBussiness.getLists<GetProducts>(
          request,
        )) as Pagination<IProductProperties>;
        self.setProp(
          "products",
          res.items?.map((x, i) => ({
            ...x,
            orderNumber:
              i + 1 + self.pagination.pageIndex * self.pagination.itemsPerPage,
          })),
        );
        self.pagination.setProp("totalItems", res.totalCount);
        self.setProp(
          "searchConditionAsNaturalLanguage",
          self.createSearchConditionAsNaturalLanguage(),
        );
      } catch (ex) {
        console.error(ex);
      } finally {
        self._rootStore.setProp("inProgress", false);
      }
    }),
    getProductDetail: flow(function* getProductDetail(id: string) {
      try {
        self._rootStore.setProp("inProgress", true);
        const res = (yield productBussiness.getById(id)) as IProductProperties;
        self.setProp("productDetail", res);
      } catch (ex) {
        console.error(ex);
      } finally {
        self._rootStore.setProp("inProgress", false);
      }
    }),
  }));
